import { Component, ViewEncapsulation } from '@angular/core';
import {HirAuthApiService} from "./shared/core-hir/hir-auth.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  private authorized: boolean = false;
  constructor(private authApiService: HirAuthApiService) {

  }
  title = 'HIR';

  toastOptions = {
    position: ["top", "right"],
    timeOut: 5000,
    lastOnBottom: true
  }
}
